import { useCallback, useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { useAuth } from "@/context/AuthContext";
import { api, fmtAZN } from "@/lib/api";
import { DepositForm } from "@/components/wallet/DepositForm";
import { WithdrawForm } from "@/components/wallet/WithdrawForm";
import { TxList } from "@/components/wallet/TxList";
import { PromoRedeem } from "@/components/PromoRedeem";

const tabCls = "rounded-full px-5 py-2.5 data-[state=active]:bg-[#D4AF37] data-[state=active]:text-black text-zinc-400 font-semibold";

export default function Wallet() {
  const { user, refresh } = useAuth();
  const [txs, setTxs] = useState([]);
  const [info, setInfo] = useState(null);
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "deposit";

  const load = useCallback(async () => {
    const { data } = await api.get("/wallet/transactions");
    setTxs(data);
    refresh();
  }, [refresh]);

  useEffect(() => {
    api.get("/wallet/info").then(({ data }) => setInfo(data));
    load();
  }, [load]);

  return (
    <div className="max-w-6xl mx-auto px-4 sm:px-8 py-12" data-testid="wallet-page">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
        <div>
          <p className="text-sm uppercase tracking-[0.2em] text-[#D4AF37]">Kassa</p>
          <h1 className="font-display font-black text-4xl sm:text-5xl tracking-tighter mt-2">Pul kisəsi</h1>
        </div>
        <div className="rounded-2xl border border-[#D4AF37]/40 bg-[#111] px-8 py-5">
          <p className="text-xs uppercase tracking-[0.2em] text-zinc-500">Balans</p>
          <p className="font-display font-black text-3xl gold-text" data-testid="wallet-balance">{fmtAZN(user?.balance)}</p>
        </div>
      </div>
      <Tabs value={tab} onValueChange={(v) => setParams({ tab: v }, { replace: true })}>
        <TabsList className="bg-[#111] border border-white/10 rounded-full p-1 h-auto mb-8 flex-wrap justify-start">
          <TabsTrigger value="deposit" className={tabCls} data-testid="tab-deposit">Depozit</TabsTrigger>
          <TabsTrigger value="withdraw" className={tabCls} data-testid="tab-withdraw">Çıxarış</TabsTrigger>
          <TabsTrigger value="history" className={tabCls} data-testid="tab-history">Tarixçə</TabsTrigger>
          <TabsTrigger value="promo" className={tabCls} data-testid="tab-promo">Promokod</TabsTrigger>
        </TabsList>
        <TabsContent value="deposit">{info && <DepositForm info={info} onDone={load} pending={txs.find((t) => t.type === "deposit" && t.status === "pending")} />}</TabsContent>
        <TabsContent value="withdraw">{info && <WithdrawForm info={info} onDone={load} />}</TabsContent>
        <TabsContent value="history"><TxList txs={txs} /></TabsContent>
        <TabsContent value="promo"><div className="max-w-xl"><PromoRedeem /></div></TabsContent>
      </Tabs>
    </div>
  );
}
